// extracted by mini-css-extract-plugin
export var gradient = "SectionSteppedProcess-module--gradient--60451";
export var introtext = "SectionSteppedProcess-module--introtext--6fdd7";
export var number = "SectionSteppedProcess-module--number--3c530";
export var numberborder = "SectionSteppedProcess-module--numberborder--77a63";
export var numbertitle = "SectionSteppedProcess-module--numbertitle--99b05";
export var showmore = "SectionSteppedProcess-module--showmore--1e95e";
export var step = "SectionSteppedProcess-module--step--0aa70";
export var stepcontent = "SectionSteppedProcess-module--stepcontent--64681";
export var stepcontentbottom = "SectionSteppedProcess-module--stepcontentbottom--81817 SectionSteppedProcess-module--stepcontent--64681";
export var stepintrotext = "SectionSteppedProcess-module--stepintrotext--0a981";
export var steplink = "SectionSteppedProcess-module--steplink--5d192";
export var stepordering = "SectionSteppedProcess-module--stepordering--9d05c";
export var steppedprocess = "SectionSteppedProcess-module--steppedprocess--ad86f";
export var steptitle = "SectionSteppedProcess-module--steptitle--d8690";
export var stepwrapper = "SectionSteppedProcess-module--stepwrapper--7e9c5";
export var title = "SectionSteppedProcess-module--title--72f52";
export var visibilityhidden = "SectionSteppedProcess-module--visibilityhidden--4a9c1";